import React, {useEffect, useState} from 'react';

const SelectField = ({id, label, helpBlock, values, value, onChange}) => {

  const [_value, setValue] = useState(value);

  useEffect(() => setValue(value), [value]);
  useEffect(() => {
    if (values.length > 0 && !values.some(v => v.value === _value)) {
      setValue(values[0].value);
    } else {
      onChange(_value);
    }
  }, [_value]);

  return <div className="mb-3">
    {label && <label htmlFor={id} className="form-label">{label}</label>}
    <select id={id}
            className="form-select"
            value={_value || ''}
            onChange={e => setValue(e.target.value)}>
      {values.map(v => <option key={v.value} value={v.value} disabled={!!v.disabled}>{v.label}</option>)}
    </select>
    {helpBlock && <div className="form-text">{helpBlock}</div>}
  </div>;
};

export default SelectField;
